<h2>Customer Details</h2>
<p-table #dt [value]="details" styleClass="p-datatable-striped">
    <ng-template pTemplate="header">
        <tr>
            <th *ngFor="let col of cols">
                {{col.header}}
            </th>
            <th class="w--icon">
                Edit
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="4">No records found</td>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-variable>
        <tr>
            <td *ngFor="let col of cols">
                {{col.type ? col.type.transform(variable[col.field]): variable[col.field]}}
            </td>
            <td class="text-center">
                <a class="icon--edit" title="Edit" href="javascript:void(0);" (click)="editOrg()"></a>
            </td>
        </tr>
    </ng-template>
</p-table>